import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SportConfigProvider } from './context/SportConfig';
import PrivateRoute from './components/PrivateRoute';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import DraftPlayers from './pages/DraftPlayers';
import Leagues from './pages/Leagues';
import LeagueDetail from './pages/LeagueDetail';
import SnakeDraft from './pages/SnakeDraft';
import FreeAgency from './pages/FreeAgency';
import MyTeams from './pages/MyTeams';
import Leaderboards from './pages/Leaderboards';
import AdminLeagues from './pages/AdminLeagues';
import AdminLeagueDetail from './pages/AdminLeagueDetail';
import AdminTournaments from './pages/AdminTournaments';
import News from './pages/News';
import Faq from './pages/Faq';
import JoinLeague from './pages/JoinLeague';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

function AppContent() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/news" element={<News />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/join/:code" element={<JoinLeague />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/draft"
          element={
            <PrivateRoute>
              <DraftPlayers />
            </PrivateRoute>
          }
        />
        <Route
          path="/leagues"
          element={
            <PrivateRoute>
              <Leagues />
            </PrivateRoute>
          }
        />
        <Route
          path="/leagues/:id"
          element={
            <PrivateRoute>
              <LeagueDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/teams"
          element={
            <PrivateRoute>
              <MyTeams />
            </PrivateRoute>
          }
        />
        <Route
          path="/leaderboards"
          element={
            <PrivateRoute>
              <Leaderboards />
            </PrivateRoute>
          }
        />
        <Route
          path="/leagues/:id/snake-draft"
          element={
            <PrivateRoute>
              <SnakeDraft />
            </PrivateRoute>
          }
        />
        <Route
          path="/leagues/:id/draft"
          element={
            <PrivateRoute>
              <DraftPlayers />
            </PrivateRoute>
          }
        />
        <Route
          path="/leagues/:id/free-agency"
          element={
            <PrivateRoute>
              <FreeAgency />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/leagues"
          element={
            <PrivateRoute>
              <AdminLeagues />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/leagues/:id"
          element={
            <PrivateRoute>
              <AdminLeagueDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/tournaments"
          element={
            <PrivateRoute>
              <AdminTournaments />
            </PrivateRoute>
          }
        />
      </Routes>
      <footer className="app-footer">
        <p className="footer-copyright">&copy; 2026 Play Fantastic, LLC</p>
        <p className="footer-contact">
          Questions? Comments? Concerns? Let us know!{' '}
          <a href="mailto:support@playfantastic.net">support@playfantastic.net</a>
        </p>
      </footer>
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <SportConfigProvider>
            <AppContent />
          </SportConfigProvider>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
